import React from "react";
const CaptainTCCashbackCardTerms = (props) => {
  return (
    <section
      id="id_ico_about_section "
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between pt-5">
          <div className="col-lg-12">
            <ul className="list-unstyled">
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
              >
                <p className="text-dark fw-semibold opacity-50 mb-0">
                  Last updated: 30 May 2026
                </p>
                <p className="text-dark fw-semibold opacity-50 mb-0">
                  Company: TopCoin UK Ltd
                </p>
                <p className="text-dark fw-semibold opacity-50 mb-0">
                  Company Registration No: 16483297
                </p>
                <p className="text-dark fw-semibold opacity-50 mb-3">
                  Contact: info@topcoinuk.com
                </p>
              </li>

              {/* 1. Who we are */}
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">1. Who we are</h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  TopCoin UK Ltd ("TopCoin UK") is an advertising, rewards and
                  discount company registered in England &amp; Wales (Company No.
                  16483297). TopCoin UK is not a cryptocurrency, gambling or
                  investment business.
                </p>
              </li>

              {/* 2. Key definitions */}
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">2. Key definitions</h5>
                <ul className="text-dark opacity-50">
                  <li className="mb-2">
                    <strong>Captain TC Cash-Back Card</strong> – The digital or
                    physical card you purchase to unlock the promotions in
                    Section 5.
                  </li>
                  <li className="mb-2">
                    <strong>Main Wallet</strong> – Your default TopCoin balance
                    earned on eligible purchases.
                  </li>
                  <li className="mb-2">
                    <strong>Reward Card Promotion</strong> – Receive TopCoin
                    rewards when you buy the card. Opens when you reach 5,000
                    TopCoin in your Extra Card Promotion.
                  </li>
                  <li className="mb-2">
                    <strong>Extra Card Promotion</strong> – Every TopCoin
                    collected in your Main Wallet is matched 1-for-1 and added
                    to your Extra Card balance.
                  </li>
                  <li className="mb-2">
                    <strong>Bonus Card Promotion</strong> – Every TopCoin in
                    your Extra Card balance is multiplied by 16 and added to
                    your Bonus Card balance.
                  </li>
                  <li className="mb-2">
                    <strong>Cash Wallet</strong> – A shared cash fund held by
                    TopCoin UK for all card-holders. Your personal share unlocks
                    at 5,000 Extra-Card TopCoin.
                  </li>
                  <li className="mb-2">
                    <strong>FCA-authorised payment partner</strong> – A licensed
                    electronic-money / payment institution that safeguards and
                    pays out Cash Wallet funds on our behalf.
                  </li>
                </ul>
              </li>

              {/* 3. Eligibility */}
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">3. Eligibility</h5>
                <ul className="text-dark opacity-50">
                  <li>You must be at least 16 years old.</li>
                  <li>
                    You must provide a valid email address and mobile number.
                  </li>
                  <li>
                    Worldwide access: the programme is open globally; you do not
                    need to be a UK resident. Currency conversions for
                    withdrawals are handled by our FCA-authorised payment
                    partner at their standard FX rates.
                  </li>
                </ul>
              </li>

              {/* 4. Buying the card & cooling-off period */}
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">
                  4. Buying the card &amp; cooling-off period
                </h5>
                <ul className="text-dark opacity-50">
                  <li>Card price is shown at checkout.</li>
                  <li>
                    14-day cooling-off: you may cancel within 14 days for a full
                    refund provided you have not used the card or redeemed any
                    TopCoin linked to it (email info@topcoinuk.com).
                  </li>
                </ul>
              </li>

              {/* 5. How you earn TopCoin */}
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">
                  5. How you earn TopCoin
                </h5>
                <ul className="text-dark opacity-50">
                  <li>
                    <strong>Purchase Reward</strong> – Instant TopCoin when you
                    buy the card.
                  </li>
                  <li>
                    <strong>Reward Card Promotion</strong> – Receive TopCoin
                    rewards when you buy the card.
                  </li>
                  <li>
                    <strong>Extra Card Promotion</strong> – Every TopCoin
                    collected in your Main Wallet is matched 1-for-1 into your
                    Extra Card balance.
                  </li>
                  <li>
                    <strong>Bonus Card Promotion</strong> – Every TopCoin in
                    your Extra Card balance is multiplied by 16 and added to
                    your Bonus Card balance.
                  </li>
                </ul>
                <p className="info_description text-dark opacity-50 mb-0 mt-2">
                  All TopCoin is funded entirely by commissions/discounts
                  supplied by participating merchants; customers never purchase
                  TopCoin with cash.
                </p>
              </li>

              {/* 6. Cash Wallet */}
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">6. Cash Wallet</h5>
                <ul className="text-dark opacity-50">
                  <li>
                    <strong>Pool structure</strong> – a single safeguarded
                    account held by our FCA-authorised payment partner.
                  </li>
                  <li>
                    <strong>Unlock trigger</strong> – your share becomes
                    withdrawable once your Extra Card balance reaches 5,000
                    TopCoin.
                  </li>
                  <li>
                    <strong>Withdrawal</strong> – you may withdraw your share at
                    any time after unlocking; a 2% processing fee is deducted
                    from each withdrawal and funds are paid to the bank/PayPal
                    account you nominate.
                  </li>
                  <li>
                    You unlock the Captain TC Cash-Back Bonus Card Promotion
                    once your Extra Card balance reaches 1,000 TopCoin.
                  </li>
                </ul>
              </li>

              {/* 7 (shown as 8 in doc). Refunds & returns */}
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">
                  7. Refunds &amp; returns
                </h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  If a transaction that earned TopCoin is refunded or cancelled,
                  the corresponding TopCoin will be removed from all related
                  balances and your Cash Wallet share adjusted.
                </p>
              </li>

              {/* 8. Account suspension & closure */}
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">
                  8. Account suspension &amp; closure
                </h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  We may suspend or close an account for fraud, abuse or breach
                  of these Terms. You may close your account at any time by
                  emailing info@topcoinuk.com.
                </p>
              </li>

              {/* 9. Data & privacy */}
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">
                  9. Data &amp; privacy
                </h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  Your data is processed under our Privacy Policy. Only the
                  minimum data required to execute withdrawals is shared with
                  our FCA-authorised payment partner.
                </p>
              </li>

              {/* 10. Liability */}
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">10. Liability</h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  We are not liable for merchant failures, unauthorised access
                  due to insecure credentials, or indirect losses. Our total
                  liability is limited to the sterling value of TopCoin in your
                  account at the time of any claim.
                </p>
              </li>

              {/* 11. Changes to these Terms */}
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">
                  11. Changes to these Terms
                </h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  We may update these Terms with 30 days' notice via email or
                  on-site notice. Continued use after the effective date
                  constitutes acceptance.
                </p>
              </li>

              {/* 12. Governing law */}
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">12. Governing law</h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  These Terms are governed by English law; disputes are subject
                  to the courts of England &amp; Wales.
                </p>
              </li>

              {/* Contact */}
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">Need help?</h5>
                <ul className="info_description text-dark opacity-50 mb-0">
                  <li>
                    Email: <strong>info@topcoinuk.com</strong>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaptainTCCashbackCardTerms;
